import { withModifiers as _withModifiers, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-616729dd"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal-box",
  ref: "target"
}
const _hoisted_2 = { class: "modal-close" }
const _hoisted_3 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Slide = _resolveComponent("Slide")!
  const _component_Navigation = _resolveComponent("Navigation")!
  const _component_Carousel = _resolveComponent("Carousel")!

  return (_ctx.isOpen)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "modal-mask",
        id: "outside-modal",
        onMousedown: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleMouseDown && _ctx.handleMouseDown(...args))),
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleOutsideClick && _ctx.handleOutsideClick(...args)))
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.emit('modal-close')), ["stop"]))
            })
          ]),
          _createVNode(_component_Carousel, {
            ref: "carouselElement",
            class: "images-carousel",
            "wrap-around": true,
            "items-to-show": 1,
            snapAlign: "start"
          }, {
            addons: _withCtx(() => [
              _createVNode(_component_Navigation)
            ]),
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.imageList, (image, index) => {
                return (_openBlock(), _createBlock(_component_Slide, {
                  key: index,
                  class: "image-slider"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("img", {
                      src: image.url,
                      class: "image-inner",
                      alt: "Imagem do produto"
                    }, null, 8, _hoisted_3)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }, 512)
        ], 512)
      ], 32))
    : _createCommentVNode("", true)
}